export const SERVICE_PAGES = [
  {
    slug: "pronto-intervento-cancelli-roma",
    icon: "DoorOpen",
    title: "Pronto Intervento Cancelli Roma | FIX ROMA H24",
    description:
      "Cancello automatico bloccato a Roma? Pronto intervento H24 per cancelli, motori, fotocellule e automazioni a Roma e provincia. Chiama il 06 8590 2421.",
    h1: "Pronto intervento cancelli a Roma",
    sub: "Cancello automatico bloccato, problemi di apertura o chiusura, motori e fotocellule: assistenza urgente a Roma e provincia, anche di notte.",
    image: "/images/hero.webp",
    imageAlt: "Cancello automatico scorrevole con motorizzazione",
    problemsTitle: "Problemi con il cancello che gestiamo",
    problems: [
      "Il cancello automatico non si apre né si chiude",
      "Il motore fa rumore ma l'anta non si muove",
      "Le fotocellule bloccano la chiusura",
      "Il telecomando non comanda più il cancello",
      "Il cancello è rimasto bloccato a metà corsa",
    ],
    paragraphs: [
      "Un cancello bloccato può significare restare fuori o dentro casa, oppure lasciare un negozio o un box non protetto. FIX ROMA H24 gestisce richieste di pronto intervento per cancelli automatici e manuali a Roma e provincia, con particolare attenzione alle urgenze delle ore serali e notturne.",
      "Al telefono descrivi il problema e indichi la tua zona: valutiamo subito la disponibilità del servizio. Se possiamo gestire direttamente il lavoro interveniamo noi; quando necessario, verifichiamo la disponibilità di un professionista partner nella tua area.",
      "Interveniamo su cancelli scorrevoli e a battente, motori, fotocellule, centraline e telecomandi. Se cerchi un pronto intervento per un cancello automatico bloccato a Roma, la chiamata è il modo più rapido per capire come risolvere.",
    ],
    faqs: [
      {
        q: "Il cancello automatico è bloccato: cosa devo fare?",
        a: "Evita di forzare il movimento, rischi di peggiorare il danno. Chiamaci e descrivi cosa succede: ti diremo subito come comportarti e verificheremo la disponibilità dell'intervento nella tua zona.",
      },
      {
        q: "Intervenite sui cancelli anche di sera o di notte?",
        a: "Il servizio è pensato per gestire richieste urgenti anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
      {
        q: "In quali zone intervenite per i cancelli?",
        a: "Interveniamo a Roma e provincia. La disponibilità può variare in base alla zona e al tipo di intervento: indicaci dove ti trovi e lo verifichiamo subito.",
      },
    ],
    serviceType: "Pronto intervento cancelli",
  },
  {
    slug: "pronto-intervento-serrande-roma",
    icon: "Warehouse",
    title: "Pronto Intervento Serrande Roma | FIX ROMA H24",
    description:
      "Serranda elettrica bloccata a Roma? Pronto intervento H24 per serrande di negozi, box e garage a Roma e provincia. Chiama ora il 06 8590 2421.",
    h1: "Pronto intervento serrande a Roma",
    sub: "Serranda elettrica bloccata o serranda manuale che non scorre? Assistenza urgente per negozi, box e garage a Roma e provincia.",
    image: "/images/city.webp",
    imageAlt: "Strada commerciale di Roma con serrande dei negozi",
    problemsTitle: "Problemi con la serranda che gestiamo",
    problems: [
      "La serranda elettrica è bloccata a metà",
      "Il motore non risponde ai comandi",
      "La serranda manuale è dura o bloccata",
      "Problemi di apertura e chiusura",
      "Guide o componenti meccanici danneggiati",
    ],
    paragraphs: [
      "Una serranda bloccata ferma un'attività: il negozio non apre, il box resta chiuso, il garage è inutilizzabile. FIX ROMA H24 gestisce richieste di pronto intervento per serrande elettriche e manuali a Roma e provincia, anche nelle ore serali e notturne.",
      "Chiamando descrivi il problema e la tua zona: valutiamo subito la disponibilità del servizio. Se possiamo gestire direttamente il lavoro interveniamo noi; quando necessario, verifichiamo la disponibilità di un professionista partner.",
      "Lavoriamo su motori, molle, guide, avvolgibili e componenti delle serrande. Se hai una serranda elettrica bloccata a Roma, chiamaci: la telefonata è il modo più rapido per ripartire.",
    ],
    faqs: [
      {
        q: "La serranda del negozio è bloccata prima dell'apertura: potete intervenire?",
        a: "Chiamaci subito e descrivi la situazione: verifichiamo la disponibilità del servizio nella tua zona e ti diciamo come possiamo gestirla.",
      },
      {
        q: "Vi occupate anche di serrande manuali?",
        a: "Sì, gestiamo sia serrande elettriche sia manuali: blocchi, problemi di scorrimento, motori e componenti meccanici.",
      },
      {
        q: "Intervenite sulle serrande anche di notte?",
        a: "Il servizio è pensato per gestire urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
    ],
    serviceType: "Pronto intervento serrande",
  },
  {
    slug: "automazioni-cancelli-roma",
    icon: "Cog",
    title: "Automazioni Cancelli Roma | Motori e Centraline — FIX ROMA H24",
    description:
      "Automazioni per cancelli a Roma: motori, centraline, fotocellule e telecomandi. Assistenza urgente H24 a Roma e provincia. Chiama il 06 8590 2421.",
    h1: "Automazioni per cancelli a Roma",
    sub: "Motori, centraline, fotocellule e telecomandi: assistenza sui malfunzionamenti delle automazioni a Roma e provincia, anche di notte.",
    image: "/images/hero.webp",
    imageAlt: "Componenti meccanici di precisione di un'automazione",
    problemsTitle: "Malfunzionamenti delle automazioni che gestiamo",
    problems: [
      "Il motore dell'automazione non risponde",
      "La centralina segnala un errore",
      "Le fotocellule sono disallineate o non funzionano",
      "Il telecomando non apre più il cancello",
      "L'automazione funziona in modo intermittente",
    ],
    paragraphs: [
      "Quando un'automazione smette di funzionare, il cancello diventa un problema quotidiano: si apre a metà, non risponde al telecomando o si blocca senza motivo apparente. FIX ROMA H24 gestisce richieste di assistenza su automazioni per cancelli a Roma e provincia.",
      "Al telefono descrivi il sintomo e indichi la tua zona: valutiamo il problema e la disponibilità del servizio. Se possiamo gestire direttamente il lavoro interveniamo noi; quando necessario, verifichiamo la disponibilità di un professionista partner.",
      "Interveniamo su motori, centraline di comando, fotocellule di sicurezza, telecomandi e riceventi. Per un guasto alle automazioni dei cancelli a Roma, la chiamata è il primo passo.",
    ],
    faqs: [
      {
        q: "Il telecomando non apre più il cancello: cosa può essere?",
        a: "Le cause possibili sono diverse: batterie, ricevente, centralina o motore. Chiamaci e descrivi il sintomo: ti aiutiamo a capire da dove partire.",
      },
      {
        q: "Le fotocellule bloccano la chiusura del cancello, intervenite?",
        a: "Sì, fotocellule disallineate o sporche sono una causa frequente di blocco. Descrivici il problema al telefono e valutiamo l'intervento.",
      },
      {
        q: "Fate assistenza sulle automazioni anche di sera?",
        a: "Il servizio è pensato per richieste urgenti anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
    ],
    serviceType: "Assistenza automazioni cancelli",
  },
  {
    slug: "pronto-intervento-serrature-roma",
    icon: "KeyRound",
    title: "Pronto Intervento Serrature Roma | FIX ROMA H24",
    description:
      "Serratura bloccata a Roma? Pronto intervento H24 per serrature e accessi a Roma e provincia, con sostituzioni quando appropriate. Chiama il 06 8590 2421.",
    h1: "Pronto intervento serrature a Roma",
    sub: "Serratura bloccata, chiave che non gira o accesso impossibile? Assistenza urgente a Roma e provincia, anche di notte.",
    image: "/images/night.webp",
    imageAlt: "Primo piano di serratura e chiave in metallo",
    problemsTitle: "Problemi con serrature e accessi che gestiamo",
    problems: [
      "La chiave non gira nella serratura",
      "La serratura è bloccata o danneggiata",
      "La porta blindata non si apre",
      "Problemi di accesso a casa, box o attività",
      "Sostituzione della serratura quando appropriato",
    ],
    paragraphs: [
      "Una serratura bloccata è sempre un'urgenza: non entri in casa, non apri il negozio, non accedi al box. FIX ROMA H24 gestisce richieste di pronto intervento per serrature e accessi a Roma e provincia, con attenzione alle ore serali e notturne.",
      "Al telefono descrivi il problema e indichi la tua zona: valutiamo la situazione e la disponibilità del servizio. Gli interventi e le eventuali sostituzioni vengono effettuati quando tecnicamente e professionalmente appropriati.",
      "Se cerchi un pronto intervento serrature a Roma, chiamaci: descrivici il tipo di porta e il problema, e ti diremo come possiamo gestirlo.",
    ],
    faqs: [
      {
        q: "La chiave non gira nella serratura: cosa faccio?",
        a: "Non forzare la chiave: rischi di spezzarla dentro la serratura. Chiamaci e descrivi il problema, ti indicheremo come comportarti.",
      },
      {
        q: "Sostituite le serrature?",
        a: "Sì, effettuiamo interventi e sostituzioni quando tecnicamente e professionalmente appropriati. Descrivici la tua situazione al telefono.",
      },
      {
        q: "Intervenite sulle serrature anche di notte?",
        a: "Il servizio è pensato per gestire urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
    ],
    serviceType: "Pronto intervento serrature",
  },
  {
    slug: "elettricista-pronto-intervento-roma",
    icon: "Zap",
    title: "Elettricista Pronto Intervento Roma H24 | FIX ROMA H24",
    description:
      "Elettricista pronto intervento a Roma H24: assistenza per guasti elettrici urgenti a Roma e provincia, anche di notte. Chiama ora il 06 8590 2421.",
    h1: "Elettricista pronto intervento a Roma",
    sub: "Guasti elettrici urgenti a Roma e provincia: descrivi il problema e verifichiamo subito la disponibilità del servizio, anche di sera e di notte.",
    image: "/images/night.webp",
    imageAlt: "Roma di notte durante un intervento serale",
    problemsTitle: "Guasti elettrici urgenti che gestiamo",
    problems: [
      "Il salvavita scatta di continuo",
      "Manca la corrente in una parte della casa o del negozio",
      "Prese o interruttori non funzionano",
      "Blackout improvviso dell'attività",
      "Problemi elettrici su cancelli e automazioni",
    ],
    paragraphs: [
      "Un guasto elettrico improvviso blocca tutto: la casa resta al buio, il negozio non può aprire, il cancello automatico non risponde. FIX ROMA H24 gestisce richieste di pronto intervento elettrico a Roma e provincia, con particolare attenzione alle urgenze serali e notturne.",
      "Chiamando descrivi il problema e la tua zona: valutiamo subito la disponibilità del servizio. Se possiamo gestire direttamente il lavoro interveniamo noi; quando necessario, verifichiamo la disponibilità di un professionista partner.",
      "Se cerchi un elettricista per un pronto intervento a Roma, anche in orario notturno, la chiamata è il modo più rapido per capire come risolvere il guasto.",
    ],
    faqs: [
      {
        q: "Il salvavita scatta di continuo: potete intervenire?",
        a: "Chiamaci e descrivi cosa succede: quando scatta, cosa smette di funzionare, da quando. Valuteremo la disponibilità dell'intervento nella tua zona.",
      },
      {
        q: "Fate interventi elettrici anche di notte?",
        a: "Il servizio è pensato per gestire urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
      {
        q: "Quanto costa un intervento elettrico?",
        a: "Il costo dipende dal tipo di guasto e dall'intervento necessario. Contattaci descrivendo il tuo caso: valuteremo insieme la soluzione più adatta.",
      },
    ],
    serviceType: "Pronto intervento elettrico",
  },
  {
    slug: "pronto-intervento-notturno-roma",
    icon: "MoonStar",
    title: "Pronto Intervento Notturno Roma | Anche di Notte — FIX ROMA H24",
    description:
      "Pronto intervento notturno a Roma: cancelli, serrande, serrature e guasti elettrici gestiti anche di sera e di notte, a Roma e provincia. Chiama il 06 8590 2421.",
    h1: "Pronto intervento notturno a Roma",
    sub: "Cancello bloccato a mezzanotte, serranda che non chiude la sera, guasto elettrico improvviso: FIX ROMA H24 è pensato per gestire richieste urgenti anche nelle ore serali e notturne.",
    image: "/images/night.webp",
    imageAlt: "Roma di notte, strade illuminate durante un intervento serale",
    problemsTitle: "Le urgenze notturne che gestiamo",
    problems: [
      "Il cancello non si apre quando rientri la sera",
      "La serranda del negozio non chiude a fine giornata",
      "Il salvavita scatta nel cuore della notte",
      "La serratura si blocca fuori orario",
      "L'automazione smette di funzionare all'improvviso",
    ],
    paragraphs: [
      "I guasti non guardano l'orologio: capitano la sera tardi, la notte, nei weekend. FIX ROMA H24 nasce proprio per questo: gestire richieste di pronto intervento anche nelle ore serali e notturne a Roma e provincia, quando la maggior parte dei servizi è chiusa.",
      "Di notte il primo passo è sempre una telefonata: descrivi il problema, indica la tua zona e valutiamo subito la disponibilità del servizio. Se possiamo gestire direttamente il lavoro interveniamo noi; quando necessario, verifichiamo la disponibilità di un professionista partner.",
      "Cancelli, serrande, automazioni, serrature e guasti elettrici: se hai un'urgenza notturna a Roma, chiama il 06 8590 2421. La telefonata è il modo più rapido per capire come risolvere.",
    ],
    faqs: [
      {
        q: "Di notte risponde qualcuno al telefono?",
        a: "Il numero 06 8590 2421 è il riferimento per le richieste serali e notturne: chiamaci e verifichiamo subito la disponibilità del servizio per il tuo caso.",
      },
      {
        q: "Quali interventi fate durante la notte?",
        a: "Le stesse aree del servizio diurno: cancelli automatici, serrande, automazioni, serrature e guasti elettrici urgenti, a Roma e provincia.",
      },
      {
        q: "Gli interventi notturni hanno costi diversi?",
        a: "Il costo dipende dal tipo di problema e dall'intervento necessario. Contattaci descrivendo il tuo caso: valuteremo insieme la soluzione più adatta.",
      },
    ],
    serviceType: "Pronto intervento notturno",
  },
  {
    slug: "cancello-automatico-bloccato-roma",
    icon: "DoorOpen",
    title: "Cancello Automatico Bloccato Roma | Cosa Fare — FIX ROMA H24",
    description:
      "Cancello automatico bloccato a Roma? Non forzare il movimento: chiamaci e descrivi il problema. Assistenza urgente H24 a Roma e provincia, anche di notte.",
    h1: "Cancello automatico bloccato a Roma",
    sub: "Il cancello non si apre, non si chiude o si è fermato a metà corsa? Non forzare il movimento: chiamaci e descrivi cosa succede.",
    image: "/images/hero.webp",
    imageAlt: "Cancello automatico scorrevole bloccato su binario",
    problemsTitle: "I sintomi più frequenti di un cancello bloccato",
    problems: [
      "Il motore gira ma il cancello non si muove",
      "Il cancello si ferma a metà corsa",
      "Le fotocellule impediscono la chiusura",
      "Il telecomando non dà alcun segnale",
      "Il cancello è bloccato in apertura o in chiusura",
    ],
    paragraphs: [
      "Un cancello automatico bloccato va gestito con cautela: forzare ante o scorrevoli può trasformare un piccolo guasto in un danno meccanico serio. La cosa migliore è fermarsi e descrivere il sintomo a chi se ne occupa.",
      "Le cause più frequenti sono motori in avaria, fotocellule sporche o disallineate, centraline in errore, telecomandi scarichi o problemi meccanici a guide e cerniere. Al telefono ti aiutiamo a capire da dove partire e verifichiamo la disponibilità dell'intervento nella tua zona.",
      "FIX ROMA H24 gestisce richieste per cancelli automatici bloccati a Roma e provincia, anche nelle ore serali e notturne. Chiama il 06 8590 2421 e descrivi il problema.",
    ],
    faqs: [
      {
        q: "Posso sbloccare manualmente il cancello automatico?",
        a: "Molti motori hanno un sistema di sblocco manuale, ma usarlo nel modo sbagliato può peggiorare il danno. Chiamaci: ti guidiamo al telefono o valutiamo l'intervento.",
      },
      {
        q: "Il cancello si apre ma non si chiude: cosa può essere?",
        a: "Spesso sono le fotocellule sporche o disallineate, oppure la centralina. Descrivici il sintomo al telefono e ti diremo come muoverti.",
      },
      {
        q: "Intervenite sui cancelli bloccati anche di notte?",
        a: "Il servizio è pensato per gestire urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
    ],
    serviceType: "Cancello automatico bloccato",
  },
  {
    slug: "serranda-elettrica-bloccata-roma",
    icon: "Warehouse",
    title: "Serranda Elettrica Bloccata Roma | Pronto Intervento H24",
    description:
      "Serranda elettrica bloccata a Roma? Negozio che non apre o non chiude? Assistenza urgente H24 a Roma e provincia. Chiama ora il 06 8590 2421.",
    h1: "Serranda elettrica bloccata a Roma",
    sub: "La serranda si è fermata a metà, il motore non risponde o il negozio non può chiudere? Chiamaci e descrivi il problema.",
    image: "/images/city.webp",
    imageAlt: "Strada commerciale di Roma con serrande",
    problemsTitle: "I sintomi più frequenti di una serranda bloccata",
    problems: [
      "La serranda si ferma a metà corsa",
      "Il motore non risponde ai comandi",
      "La serranda scende ma non risale",
      "Rumori anomali in apertura o chiusura",
      "Il pulsante o il telecomando non comandano la serranda",
    ],
    paragraphs: [
      "Per un negozio, una serranda elettrica bloccata è un'urgenza doppia: se non si alza non puoi aprire, se non scende non puoi chiudere e l'attività resta esposta. Non forzare la saracinesca a mano: rischi di peggiorare il danno a motore e avvolgibile.",
      "Le cause tipiche sono motori in avaria, finecorsa da ricalibrare, pulsantiere o telecomandi che non comunicano, guide ostruite o componenti usurati. Al telefono descrivi il sintomo e la tua zona: valutiamo subito la disponibilità del servizio.",
      "FIX ROMA H24 gestisce richieste per serrande elettriche bloccate a Roma e provincia, anche nelle ore serali e notturne. Chiama il 06 8590 2421.",
    ],
    faqs: [
      {
        q: "La serranda del negozio non si alza: devo tenere chiuso?",
        a: "Chiamaci subito: descrivici il sintomo e la zona, verifichiamo la disponibilità dell'intervento e ti diciamo come comportarti nel frattempo.",
      },
      {
        q: "Sostituite il motore della serranda se è rotto?",
        a: "Valutiamo al telefono il tipo di guasto: se la sostituzione del motore o dei componenti è la soluzione tecnicamente appropriata, la gestiamo.",
      },
      {
        q: "Intervenite sulle serrande anche la sera?",
        a: "Il servizio è pensato per urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
    ],
    serviceType: "Serranda elettrica bloccata",
  },
  {
    slug: "pronto-intervento-roma",
    icon: "PhoneCall",
    title: "Pronto Intervento Roma H24 | Cancelli, Serrande, Serrature",
    description:
      "Pronto intervento H24 a Roma e provincia: cancelli, serrande, automazioni, serrature e guasti elettrici urgenti, anche di notte. Chiama il 06 8590 2421.",
    h1: "Pronto intervento a Roma, H24",
    sub: "Cancelli, serrande, automazioni, serrature e guasti elettrici: un solo numero per le urgenze tecniche a Roma e provincia, anche di notte.",
    image: "/images/night.webp",
    imageAlt: "Intervento tecnico su meccanismo metallico",
    problemsTitle: "Le urgenze tecniche che gestiamo a Roma",
    problems: [
      "Cancelli automatici bloccati o che non si aprono",
      "Serrande elettriche o manuali bloccate",
      "Automazioni, motori e telecomandi che non rispondono",
      "Serrature bloccate e problemi di accesso",
      "Guasti elettrici urgenti in casa o in attività",
    ],
    paragraphs: [
      "FIX ROMA H24 è il punto di riferimento unico per le urgenze tecniche a Roma e provincia: invece di cercare un tecnico diverso per ogni problema, fai una sola telefonata e descrivi la situazione.",
      "Il percorso è semplice: chiami e indichi il problema e la tua zona, noi valutiamo la disponibilità del servizio, poi interveniamo noi direttamente oppure — quando necessario — verifichiamo la disponibilità di un professionista partner nella tua area.",
      "Il servizio è pensato per gestire le richieste anche nelle ore serali e notturne. Per qualsiasi urgenza tecnica a Roma, chiama il 06 8590 2421.",
    ],
    faqs: [
      {
        q: "Che tipo di urgenze gestite?",
        a: "Cancelli automatici, serrande, automazioni, serrature e accessi, guasti elettrici urgenti: a Roma e provincia, anche nelle ore serali e notturne.",
      },
      {
        q: "Come funziona il servizio?",
        a: "Chiami e descrivi il problema e la zona, noi valutiamo la disponibilità, poi interveniamo direttamente noi o tramite un professionista partner quando necessario.",
      },
      {
        q: "Quanto costa un pronto intervento a Roma?",
        a: "Il costo dipende dal tipo di problema e dall'intervento necessario. Contattaci descrivendo il tuo caso: valuteremo insieme la soluzione più adatta.",
      },
    ],
    serviceType: "Pronto intervento",
  },
  {
    slug: "riparazione-cancelli-roma",
    icon: "Wrench",
    title: "Riparazione Cancelli Roma | Automatici e Manuali — FIX ROMA H24",
    description:
      "Riparazione cancelli a Roma: ante disallineate, motori rumorosi, guide e cerniere usurate. Assistenza H24 a Roma e provincia. Chiama il 06 8590 2421.",
    h1: "Riparazione cancelli a Roma",
    sub: "Il cancello cigola, si muove a scatti o non chiude più bene? Meglio ripararlo prima che si blocchi del tutto: a Roma e provincia, anche di sera.",
    image: "/images/city.webp",
    imageAlt: "Meccanismo metallico di un cancello in riparazione",
    problemsTitle: "I segnali che il cancello va riparato",
    problems: [
      "Il cancello cigola o si muove a scatti",
      "L'anta è disallineata o tocca a terra",
      "La chiusura non è più precisa",
      "Il motore è diventato rumoroso",
      "Cerniere, guide o ruote mostrano usura",
    ],
    paragraphs: [
      "Un cancello raramente si rompe all'improvviso: prima cigola, rallenta, chiude male. Intervenire su questi segnali evita il blocco completo, che costa sempre di più in termini di tempo e disagi.",
      "FIX ROMA H24 gestisce richieste di riparazione per cancelli automatici e manuali a Roma e provincia: parti meccaniche, motori, fotocellule, centraline e telecomandi. Al telefono descrivi il sintomo e valutiamo insieme l'intervento.",
      "Se possiamo gestire direttamente il lavoro interveniamo noi; quando necessario, verifichiamo la disponibilità di un professionista partner. Chiama il 06 8590 2421 e indica la tua zona.",
    ],
    faqs: [
      {
        q: "Riparate anche cancelli manuali, senza motore?",
        a: "Sì: ante disallineate, cerniere, guide e serrature dei cancelli manuali. Descrivici il problema al telefono e valutiamo l'intervento.",
      },
      {
        q: "Quando conviene riparare invece di sostituire?",
        a: "Dipende dallo stato del cancello e del motore: spesso una riparazione mirata risolve il problema. Chiamaci e descrivici la situazione per una valutazione.",
      },
      {
        q: "In quali zone fate riparazioni di cancelli?",
        a: "A Roma e provincia. La disponibilità può variare in base alla zona e al tipo di intervento: indicaci dove ti trovi e lo verifichiamo subito.",
      },
    ],
    serviceType: "Riparazione cancelli",
  },
  {
    slug: "apertura-porte-roma",
    icon: "DoorClosed",
    title: "Apertura Porte Roma | Fabbro Urgente H24 — FIX ROMA H24",
    description:
      "Chiuso fuori casa a Roma? Apertura porte e porte blindate a Roma e provincia, anche di notte. Non forzare la porta: chiama ora il 06 8590 2421.",
    h1: "Apertura porte a Roma",
    sub: "Sei rimasto chiuso fuori casa? Porta blindata che non si apre? Chiavi dimenticate o spezzate? Assistenza urgente a Roma e provincia, anche di notte.",
    image: "/images/city.webp",
    imageAlt: "Portoni d'ingresso di un quartiere di Roma",
    problemsTitle: "Quando chiamarci per l'apertura porte",
    problems: [
      "La porta si è chiusa e le chiavi sono rimaste dentro",
      "La chiave si è spezzata nella serratura",
      "La porta blindata non si apre",
      "La serratura gira a vuoto",
      "Hai perso le chiavi di casa",
    ],
    paragraphs: [
      "Restare chiusi fuori casa è una delle urgenze più stressanti: spesso succede la sera, di notte o nei giorni festivi, quando sembra impossibile trovare qualcuno. FIX ROMA H24 gestisce richieste di apertura porte a Roma e provincia, con particolare attenzione proprio a questi orari.",
      "Il primo passo è una telefonata: descrivi la situazione — tipo di porta, tipo di serratura, cosa è successo — e indica la tua zona. Valutiamo subito la disponibilità del servizio: se possiamo gestire direttamente il lavoro interveniamo noi, altrimenti verifichiamo la disponibilità di un professionista partner.",
      "Le aperture vengono effettuate quando tecnicamente e professionalmente appropriati, valutando il caso al telefono prima dell'intervento. Se sei chiuso fuori casa a Roma, chiama il 06 8590 2421.",
    ],
    faqs: [
      {
        q: "Fate apertura porte come un fabbro?",
        a: "Sì: gestiamo aperture di porte di casa e porte blindate, oltre a problemi di serrature e accessi, quando tecnicamente e professionalmente appropriati. Descrivici la situazione al telefono.",
      },
      {
        q: "Sono chiuso fuori casa di notte: potete intervenire?",
        a: "Il servizio è pensato per gestire urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci e verifichiamo subito la disponibilità nella tua zona.",
      },
      {
        q: "Quanto costa l'apertura di una porta?",
        a: "Il costo dipende dal tipo di porta, di serratura e dall'intervento necessario. Contattaci descrivendo il tuo caso: valuteremo insieme la soluzione più adatta.",
      },
    ],
    serviceType: "Apertura porte",
  },
  {
    slug: "fabbro-pronto-intervento-roma",
    icon: "Hammer",
    title: "Fabbro Pronto Intervento Roma H24 | FIX ROMA H24",
    description:
      "Fabbro pronto intervento a Roma H24: apertura porte, serrature, serrande e cancelli a Roma e provincia, anche di notte. Chiama il 06 8590 2421.",
    h1: "Fabbro pronto intervento a Roma",
    sub: "Porte, serrature, serrande e cancelli: un servizio di pronto intervento tecnico a Roma e provincia, pensato anche per le ore serali e notturne.",
    image: "/images/hero.webp",
    imageAlt: "Intervento tecnico su cancello automatico a Roma",
    problemsTitle: "Le urgenze da fabbro che gestiamo",
    problems: [
      "Apertura porte di casa e porte blindate",
      "Serrature bloccate o da sostituire",
      "Serrande di negozi e box bloccate",
      "Cancelli automatici che non si aprono",
      "Interventi urgenti quando tecnicamente appropriati",
    ],
    paragraphs: [
      "Quando cerchi un fabbro urgente a Roma, il problema è sempre lo stesso: trovare qualcuno disponibile subito, soprattutto la sera o di notte. FIX ROMA H24 nasce per questo: un unico numero per le urgenze tecniche su porte, serrature, serrande e cancelli, a Roma e provincia.",
      "Al telefono descrivi il problema e indichi la tua zona: valutiamo subito la disponibilità del servizio. Se possiamo gestire direttamente il lavoro interveniamo noi; quando necessario, verifichiamo la disponibilità di un professionista partner nella tua area.",
      "Nessuna promessa impossibile: ti diciamo al telefono se e come possiamo gestire il tuo caso. Per un fabbro di pronto intervento a Roma, chiama il 06 8590 2421.",
    ],
    faqs: [
      {
        q: "Che tipo di interventi da fabbro fate?",
        a: "Apertura porte, problemi di serrature e accessi, serrande bloccate, cancelli e automazioni: descrivici il problema al telefono e ti diremo come possiamo gestirlo.",
      },
      {
        q: "Il servizio fabbro è disponibile anche di notte?",
        a: "Il servizio è pensato per gestire richieste urgenti anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
      {
        q: "In quali zone di Roma intervenite?",
        a: "A Roma e provincia. La disponibilità può variare in base alla zona e al tipo di intervento: indicaci dove ti trovi e lo verifichiamo subito.",
      },
    ],
    serviceType: "Fabbro pronto intervento",
  },
  {
    slug: "porta-blindata-bloccata-roma",
    icon: "ShieldCheck",
    title: "Porta Blindata Bloccata Roma | Pronto Intervento H24",
    description:
      "Porta blindata bloccata a Roma? Chiave che gira a vuoto o serratura in blocco? Assistenza urgente a Roma e provincia, anche di notte. Chiama il 06 8590 2421.",
    h1: "Porta blindata bloccata a Roma",
    sub: "La chiave gira a vuoto, la serratura è in blocco o la porta blindata non si apre? Non forzare: chiamaci e descrivi il problema.",
    image: "/images/night.webp",
    imageAlt: "Ingresso di un palazzo di Roma di notte",
    problemsTitle: "I sintomi più frequenti di una porta blindata bloccata",
    problems: [
      "La chiave gira a vuoto senza aprire",
      "Il meccanismo della serratura è in blocco",
      "La porta blindata non si apre né si chiude",
      "Chiave spezzata nel cilindro",
      "La serratura a doppia mappa non risponde",
    ],
    paragraphs: [
      "Una porta blindata bloccata è un'urgenza delicata: la serratura di sicurezza è fatta apposta per resistere, e forzarla senza gli strumenti giusti può danneggiare porta e telaio. Fermati e chiama prima di tentare manovre improvvisate.",
      "FIX ROMA H24 gestisce richieste per porte blindate bloccate a Roma e provincia, anche nelle ore serali e notturne. Al telefono descrivi il modello di porta, il tipo di serratura e il sintomo: valutiamo subito come intervenire e la disponibilità nella tua zona.",
      "Gli interventi e le eventuali sostituzioni di serratura o cilindro vengono effettuati quando tecnicamente e professionalmente appropriati. Chiama il 06 8590 2421 e descrivi la situazione.",
    ],
    faqs: [
      {
        q: "La chiave della porta blindata gira a vuoto: cosa faccio?",
        a: "Non insistere: spesso è un problema interno alla serratura che la forzatura peggiora. Chiamaci e descrivi il sintomo, ti diremo come comportarti.",
      },
      {
        q: "Sostituite la serratura della porta blindata?",
        a: "Sì, quando tecnicamente e professionalmente appropriato: valutiamo al telefono il tipo di serratura e ti proponiamo la soluzione più adatta.",
      },
      {
        q: "Intervenite sulle porte blindate anche di sera?",
        a: "Il servizio è pensato per urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
    ],
    serviceType: "Porta blindata bloccata",
  },
  {
    slug: "elettricista-h24-roma",
    icon: "Zap",
    title: "Elettricista H24 Roma | Pronto Intervento Notturno — FIX ROMA H24",
    description:
      "Elettricista H24 a Roma: guasti elettrici urgenti gestiti anche di sera e di notte, a Roma e provincia. Chiama ora il 06 8590 2421.",
    h1: "Elettricista H24 a Roma",
    sub: "Un guasto elettrico non aspetta l'orario d'ufficio: assistenza urgente a Roma e provincia, pensata anche per le ore serali e notturne.",
    image: "/images/night.webp",
    imageAlt: "Roma di notte durante un intervento elettrico urgente",
    problemsTitle: "Le urgenze elettriche che gestiamo",
    problems: [
      "Il salvavita scatta e la casa resta al buio",
      "Blackout improvviso in casa o in negozio",
      "Prese o interruttori che non funzionano",
      "Odore di bruciato dal quadro elettrico",
      "Il cancello automatico resta senza corrente",
    ],
    paragraphs: [
      "La sera e la notte sono i momenti peggiori per un guasto elettrico: la casa resta al buio, il frigo si ferma, il negozio non può lavorare. FIX ROMA H24 è pensato proprio per gestire queste richieste: un elettricista per urgenze a Roma e provincia, anche fuori orario.",
      "Il primo passo è una telefonata: descrivi il guasto e indica la tua zona. Valutiamo subito la disponibilità del servizio: se possiamo gestire direttamente il lavoro interveniamo noi, altrimenti verifichiamo la disponibilità di un professionista partner nella tua area.",
      "Se cerchi un elettricista H24 a Roma, chiama il 06 8590 2421: al telefono capiamo insieme la situazione e come risolverla.",
    ],
    faqs: [
      {
        q: "Cerco un elettricista H24 a Roma: a che ora posso chiamare?",
        a: "Il numero 06 8590 2421 è il riferimento per le richieste serali e notturne: chiamaci e verifichiamo subito la disponibilità del servizio per il tuo caso.",
      },
      {
        q: "Un intervento elettrico di notte costa di più?",
        a: "Il costo dipende dal tipo di guasto e dall'intervento necessario. Contattaci descrivendo il tuo caso: valuteremo insieme la soluzione più adatta.",
      },
      {
        q: "In quali zone fate interventi elettrici?",
        a: "A Roma e provincia. La disponibilità può variare in base alla zona e al tipo di intervento: indicaci dove ti trovi e lo verifichiamo subito.",
      },
    ],
    serviceType: "Elettricista H24",
  },
  {
    slug: "salvavita-scatta-roma",
    icon: "Zap",
    title: "Salvavita che Scatta Roma | Cosa Fare Subito — FIX ROMA H24",
    description:
      "Il salvavita scatta di continuo a Roma? Non riarmarlo all'infinito: descrivi il problema e verifichiamo la disponibilità. Chiama il 06 8590 2421.",
    h1: "Il salvavita scatta? Ecco cosa fare a Roma",
    sub: "Se l'interruttore generale scatta di continuo c'è un guasto da individuare: non riarmarlo all'infinito, chiamaci e descrivi la situazione.",
    image: "/images/city.webp",
    imageAlt: "Quartiere residenziale di Roma al tramonto",
    problemsTitle: "I segnali da non sottovalutare",
    problems: [
      "Il salvavita scatta appena lo riarmi",
      "Scatta quando accendi un elettrodomestico",
      "Scatta solo in certi momenti della giornata",
      "Una parte di casa resta senza corrente",
      "Il quadro elettrico emette ronzii o scatti",
    ],
    paragraphs: [
      "Il salvavita scatta per proteggerti: se lo fa di continuo, significa che l'impianto ha un problema — una dispersione, un sovraccarico o un elettrodomestico guasto. Riarmarlo all'infinito non risolve nulla e può peggiorare la situazione.",
      "Cosa fare subito: stacca gli elettrodomestici più energivori e prova a capire se lo scatto è legato a uno di loro, poi chiamaci e descrivi cosa hai osservato. Queste informazioni ci aiutano a capire il guasto prima ancora dell'intervento.",
      "FIX ROMA H24 gestisce richieste per salvavita che scattano e guasti elettrici a Roma e provincia, anche nelle ore serali e notturne. Chiama il 06 8590 2421.",
    ],
    faqs: [
      {
        q: "Perché il salvavita scatta di continuo?",
        a: "Le cause tipiche sono dispersione elettrica, sovraccarico dell'impianto o un elettrodomestico difettoso. Chiamaci e descrivi quando scatta: ti aiutiamo a capire da dove partire.",
      },
      {
        q: "È pericoloso se il salvavita continua a scattare?",
        a: "Il salvavita scatta proprio per proteggerti da un problema. Se lo fa spesso, l'impianto va verificato: meglio non ignorarlo. Chiamaci e descrivi la situazione.",
      },
      {
        q: "Intervenite anche la sera se resto senza corrente?",
        a: "Il servizio è pensato per urgenze anche nelle ore serali e notturne a Roma e provincia. Chiamaci per verificare la disponibilità.",
      },
    ],
    serviceType: "Salvavita che scatta",
  },
  {
    slug: "guasto-elettrico-roma",
    icon: "Zap",
    title: "Guasto Elettrico Roma | Pronto Intervento Urgente H24",
    description:
      "Guasto elettrico urgente a Roma? Blackout, prese che non funzionano, quadro che scatta. Assistenza a Roma e provincia. Chiama il 06 8590 2421.",
    h1: "Guasto elettrico urgente a Roma",
    sub: "Blackout improvviso, prese che non funzionano, quadro elettrico che scatta: descrivi il guasto al telefono e verifichiamo subito la disponibilità.",
    image: "/images/night.webp",
    imageAlt: "Intervento notturno per un guasto elettrico a Roma",
    problemsTitle: "I guasti elettrici urgenti che gestiamo",
    problems: [
      "Blackout improvviso in tutta la casa o l'attività",
      "Prese elettriche che non funzionano",
      "Interruttori o luci che non rispondono",
      "Il quadro elettrico scatta ripetutamente",
      "Cavi o prese che scaldano",
    ],
    paragraphs: [
      "Un guasto elettrico urgente blocca tutto: casa al buio, attività ferma, elettrodomestici spenti. In questi casi serve qualcuno da chiamare subito, non una ricerca infinita su Google.",
      "FIX ROMA H24 gestisce richieste per guasti elettrici urgenti a Roma e provincia, anche nelle ore serali e notturne. Al telefono descrivi il sintomo e la tua zona: valutiamo il problema e la disponibilità del servizio, poi interveniamo noi direttamente o tramite un professionista partner quando necessario.",
      "Se hai un guasto elettrico a Roma, chiama il 06 8590 2421: la telefonata è il modo più rapido per ripartire.",
    ],
    faqs: [
      {
        q: "È saltata la corrente in tutta la casa: cosa controllo prima di chiamare?",
        a: "Controlla se manca la corrente anche ai vicini (in quel caso potrebbe essere un problema di rete) e guarda il quadro elettrico. Poi chiamaci e descrivi cosa hai verificato.",
      },
      {
        q: "Le prese di una stanza non funzionano più: intervenite?",
        a: "Sì, descrivici il problema al telefono: valuteremo la disponibilità dell'intervento nella tua zona.",
      },
      {
        q: "Quanto costa un intervento per un guasto elettrico?",
        a: "Il costo dipende dal tipo di guasto e dall'intervento necessario. Contattaci descrivendo il tuo caso: valuteremo insieme la soluzione più adatta.",
      },
    ],
    serviceType: "Guasto elettrico urgente",
  },
];

export const getServicePage = (slug) =>
  SERVICE_PAGES.find((p) => p.slug === slug);
